import { render, staticRenderFns } from "./report-qianming.vue?vue&type=template&id=c32e8966&scoped=true"
import script from "./report-qianming.vue?vue&type=script&lang=ts"
export * from "./report-qianming.vue?vue&type=script&lang=ts"
import style0 from "./report-qianming.vue?vue&type=style&index=0&id=c32e8966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32e8966",
  null
  
)

export default component.exports